module.exports = __webpack_public_path__ + "img/cheeks_and_cheekbones.ede24087.svg";